import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as CONSTANTS from '../report-type';

@Component({
  selector: 'sp-einoive-file-type',
  templateUrl: './einoive-file-type.component.html',
  styleUrls: ['./einoive-file-type.component.scss']
})
export class EinoiveFileTypeComponent implements OnInit {
  public fileTypes = CONSTANTS.e_invoice_file_types;
  public fileTypeModel: any = undefined;
  constructor(private mdDialogRef: MatDialogRef<EinoiveFileTypeComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      isPreferenceAvailable: boolean
    }) {
  }

  ngOnInit(): void {
    console.log('isPreferenceAvailable', this.data.isPreferenceAvailable);
  }

  download() {
    this.mdDialogRef.close(this.fileTypeModel);
  }

  cancel() {
    this.fileTypeModel = undefined;
    this.mdDialogRef.close(false);
  }

  okay() {
    this.mdDialogRef.close(false);
  }

}
